module.exports = __webpack_public_path__ + "static/img/cert.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/coaches/cert.jpg
// module id = rODf
// module chunks = 0